const updateTotals = function (toggleDetails = false) {
  var details = document.querySelector(".cart-details");
  const cartItems = Array.from(
    document.querySelectorAll(".sidecart-item") || []
  );
  const currentPrices = cartItems.map(
    (item) => Number(item.getAttribute("data-current-price")) || 0
  );
  const compareAtPrices = cartItems.map(
    (item) => Number(item.getAttribute("data-compare-at-price")) || 0
  );
  const detailsToggleBtn = document.querySelector(".sicart-details-btn");

  const total = currentPrices.reduce(
    (acc, price) => acc + parseFloat(price),
    0
  );
  const subtotal = compareAtPrices.reduce(
    (acc, price) => acc + parseFloat(price),
    0
  );
  const discount = subtotal - total;

  const subtotalEl = document.querySelector(".cart-subtotal");
  const discountEl = document.querySelector(".cart-discount");


  if (subtotalEl) subtotalEl.innerHTML = formatPrice(subtotal);
  if (discountEl) discountEl.innerHTML = `- ${formatPrice(discount)}`;
    
  if ( toggleDetails ){
      details.style.display = details.style.display === "none" || details.style.display === "" ? "block" : "none";
      if(  details.style.display === "none" || details.style.display === "" ) { 
          detailsToggleBtn.classList.add('inactive') 
          detailsToggleBtn.classList.remove('active') 
      } else {
          detailsToggleBtn.classList.add('active');
          detailsToggleBtn.classList.remove('inactive');
      }
  }
};

window.updateTotals = updateTotals;

function openSicartItemKitDetails(btn) {
  const toggleSection =
    btn.parentNode?.parentNode?.parentNode?.querySelector(".toggle-section");

  if (toggleSection) {
    toggleSection.classList.toggle("active");
    btn.classList.toggle("active");
  }
}

document.addEventListener("click", function (event) {
  const btn = event.target.closest(".bundle-in-cart-toggle-button");
  if (btn) {
    event.preventDefault();
    openSicartItemKitDetails(btn);
  }

  const wasSicartDetailsBtnClicked = event.target.closest(
    ".sicart-details-btn"
  );

  if (wasSicartDetailsBtnClicked) {
    updateTotals(true);
  }
});

//RGV 2025-03-12
function dgfChangeCartUpsell() {
    try {
      const observer = new MutationObserver(() => {
        let cartDrawer = document.getElementById("cart-drawer");
        if (cartDrawer) {
          let buttons = cartDrawer.querySelectorAll(
            '[data-essential-upsell-element="add-to-cart-button"]'
          );
          let upsTitles = cartDrawer.querySelectorAll(
            '[data-essential-upsell-element="title"]'
          );
          let proTitles = cartDrawer.querySelectorAll(
            'a[data-essential-upsell-element="title"]'
          );
          // Flag para verificar se todos foram alterados
          let allButtonsUpdated = true; 
  
          // Aplicar a cor para todos os botões
          buttons.forEach(button => {
            if (button && button.style.backgroundColor !== "#00263A") {
              button.style.backgroundColor = "#00263A";
              allButtonsUpdated = false;
            }
          });
  
          // Aplicar a cor para todos os títulos
          upsTitles.forEach(title => {
            if (title) {
              title.style.color = "#00263A";
              allButtonsUpdated = false;
            }
          });
          
          // Aplicar a cor para todos os títulos de produtos
          proTitles.forEach(title => {
            if (title) {
              title.style.color = "#00263A";
              allButtonsUpdated = false;
            }
          });
  
          // Desconectar o observer apenas se todos os elementos já foram modificados
          if (allButtonsUpdated && buttons.length > 0) {
            observer.disconnect();
          }
        }
      });
  
      // Manter o observer ativo até que todos os elementos sejam atualizados
      observer.observe(document.body, { childList: true, subtree: true });
  
    } catch (e) {
      null;
    }
  }
  

document.addEventListener("DOMContentLoaded", function () {
    dgfChangeCartUpsell();
});
